import React from 'react';

const UserAvatar = () => {
  return <div></div>;
};

export default UserAvatar;
